import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import moment from 'moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'NEWMANUFACTURINGDETAILSREPORT';

export default function NewManufacturingDetailsReport(props) {
  const [title, setTitle] = useState('Manufacturing Details Report');
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [itemRequestDetail, setItemRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    manufacturingNumber: ''
  });

  const [manufacturingDetails, setmanufacturingDetails] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0',
    startDate: '',
    endDate: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickPop = event => {
    setAnchorEl(event.currentTarget);
  };
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = event => {
    setRowsPerPage(event.target.value);
  };

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [itemRequestDetail.groupID]);


  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      manufacturingNumber: ''
    });
  }, [itemRequestDetail.factoryItemID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWNEWMANUFACTURINGDETAILSREPORT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setItemRequestDetail({
      ...itemRequestDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      itemRequestDetail.groupID
    );
    setFactoryList(factories);
  }

  async function GetManufacturingDetails() {
    let model = {
      groupID: parseInt(itemRequestDetail.groupID),
      factoryID: parseInt(itemRequestDetail.factoryID),
      manufacturingNumber: itemRequestDetail.manufacturingNumber,
      startDate: moment(fromDate.toString()).format().split('T')[0],
      endDate: moment(toDate.toString()).format().split('T')[0]
    };
    getSelectedDropdownValuesForReport(model);

    const itemData = await services.GetManufacturingDetailsReport(model);
    if (itemData.statusCode == 'Success' && itemData.data != null) {
      setmanufacturingDetails(itemData.data);
      createDataForExcel(itemData.data);
      if (itemData.data.length == 0) {
        alert.error('No records to display');
      }
    } else {
      alert.error(itemData.message);
    }
  }

  async function createDataForExcel(array) {
    const res = [];
    if (array != null) {
      array.map(x => {
        const vr = {
          'Manufacture No': x.manufactureNumber || '-',
          'Manufacture Date': x.toDateOfManufaturing && moment(x.toDateOfManufaturing).isValid() && !moment(x.toDateOfManufaturing).isSame('0001-01-01')
            ? moment(x.toDateOfManufaturing).format('DD/MM/YYYY')
            : '-',
          'Green Leaf Quantity (Kg)': x.greenLeafAmount ? x.greenLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Withered Leaf Quantity (Kg)': x.witheredLeafAmount ? x.witheredLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Withered Leaf Percentage (%)': x.witheredLeafPercentage ? x.witheredLeafPercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Withering Condition': x.witheringCondition ? x.witheringCondition.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Fired Tea Quantity (Kg)': x.totalFireWeight ? x.totalFireWeight.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Gross Outturn (%)': x.grossOutTurn ? x.grossOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Made Tea Quantity (Kg)': x.gradeAmount ? x.gradeAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'No. of Grade': x.noOfGrade ? x.noOfGrade.toLocaleString(undefined) : '-',
          'Net Outturn (%)': x.netOutTurn ? x.netOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Refuse Quantity (Kg)': x.refuseAmount ? x.refuseAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          'Refuse Percentage (%)': x.refusePercentage ? x.refusePercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'
        };
        res.push(vr);
      }
      );
      const vr2 = { '': '' };
      res.push(vr2);

      const vr3 = {
        'Manufacture No': 'Group : ' + selectedSearchValues.groupName,
        'Manufacture Date': 'Factory : ' + selectedSearchValues.factoryName,
      };
      res.push(vr3);

      const vr4 = {
        'Manufacture No': 'From : ' + selectedSearchValues.startDate,
        'Manufacture Date': 'To : ' + selectedSearchValues.endDate,
      };
      res.push(vr4);
    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(manufacturingDetails);
    var settings = {
      sheetName: 'Manufacturing Details Report',
      fileName:
        'Manufacturing Details Report - ' +
        selectedSearchValues.groupName +
        ' - ' +
        selectedSearchValues.factoryName +
        '  ' +
        selectedSearchValues.startDate +
        ' - ' +
        selectedSearchValues.endDate,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Manufacturing Details Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setItemRequestDetail({
      ...itemRequestDetail,
      [e.target.name]: value
    });
    setmanufacturingDetails([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(searchForm.startDate.toString())
      .format()
      .split('T')[0];
    var endDate = moment(searchForm.endDate.toString())
      .format()
      .split('T')[0];
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      startDate: [startDate],
      endDate: [endDate]
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: itemRequestDetail.groupID,
              factoryID: itemRequestDetail.factoryID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required')
            })}
            onSubmit={() => trackPromise(GetManufacturingDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={itemRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              size='small'
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={itemRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="fromDate" style={{ marginBottom: '-8px' }}>
                              From Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="fromDate"
                                value={fromDate}
                                onChange={(e) => {
                                  setFromDate(e);
                                  setmanufacturingDetails([]);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                inputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="toDate" style={{ marginBottom: '-8px' }}>
                              To Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="toDate"
                                value={toDate}
                                onChange={(e) => {
                                  setToDate(e);
                                  setmanufacturingDetails([]);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                inputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="manufacturingNumber">
                              Manufacturing Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="manufacturingNumber"
                              onChange={e => handleChange(e)}
                              value={itemRequestDetail.manufacturingNumber}
                              variant="outlined"
                              id="manufacturingNumber"
                              size='small'
                            ></TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
                        {manufacturingDetails.length > 0 ?

                          <TableContainer>
                            <Table aria-label="caption table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">Manufacture No</TableCell>
                                  <TableCell align="left">Manufacture Date</TableCell>
                                  <TableCell align="left">Green Leaf Arrival From</TableCell>
                                  <TableCell align="left">Green Leaf Arrival To</TableCell>
                                  <TableCell align="right">Green Leaf Quantity (Kg)</TableCell>
                                  <TableCell align="right">Withered Leaf Quantity (Kg)</TableCell>
                                  <TableCell align="right">Withered Leaf Percentage (%)</TableCell>
                                  <TableCell align="left">Withering Condition</TableCell>
                                  <TableCell align="right">Fired Tea Quantity (Kg)</TableCell>
                                  <TableCell align="right">Gross Outturn (%)</TableCell>
                                  <TableCell align="right">Made Tea Quantity (Kg)</TableCell>
                                  <TableCell align="right">No. of Grade</TableCell>
                                  <TableCell align="right">Net Outturn (%)</TableCell>
                                  <TableCell align="right">Refuse Quantity (Kg)</TableCell>
                                  <TableCell align="right">Refuse Percentage (%)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {manufacturingDetails
                                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Properly slice data for pagination
                                  .map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell align="left">{data.manufactureNumber || '-'}</TableCell>
                                      <TableCell align="left">
                                        {data.toDateOfManufaturing && moment(data.toDateOfManufaturing).isValid() && !moment(data.toDateOfManufaturing).isSame('0001-01-01')
                                          ? moment(data.toDateOfManufaturing).format('DD/MM/YYYY')
                                          : '-'}
                                      </TableCell>
                                      <TableCell align="left">
                                        {data.firstCollectionDate && moment(data.firstCollectionDate).isValid() && !moment(data.firstCollectionDate).isSame('0001-01-01')
                                          ? moment(data.firstCollectionDate).format('DD/MM/YYYY')
                                          : '-'}
                                      </TableCell>
                                      <TableCell align="left">
                                        {data.lastCollectionDate && moment(data.lastCollectionDate).isValid() && !moment(data.lastCollectionDate).isSame('0001-01-01')
                                          ? moment(data.lastCollectionDate).format('DD/MM/YYYY')
                                          : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.greenLeafAmount ? data.greenLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.witheredLeafAmount ? data.witheredLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.witheredLeafPercentage ? data.witheredLeafPercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.witheringCondition ? data.witheringCondition.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.totalFireWeight ? data.totalFireWeight.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.grossOutTurn ? data.grossOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.gradeAmount ? data.gradeAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.noOfGrade ? data.noOfGrade.toLocaleString() : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.netOutTurn ? data.netOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.refuseAmount ? data.refuseAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                      <TableCell align="right">
                                        {data.refusePercentage ? data.refusePercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={manufacturingDetails.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={rowsPerPage}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer> : null}
                      </Box>
                      {manufacturingDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size='small'
                          >
                            EXCEL
                          </Button>

                          <ReactToPrint
                            documentTitle={'Manufacturing Details Report - ' +
                              selectedSearchValues.groupName +
                              ' - ' +
                              selectedSearchValues.factoryName +
                              '  ' +
                              selectedSearchValues.startDate +
                              ' - ' +
                              selectedSearchValues.endDate}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              size='small'
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}

                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              manufacturingDetails={manufacturingDetails} searchData={selectedSearchValues}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
